import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';

import { map, withLatestFrom } from 'rxjs/operators';
import { Actions } from '../../actions';
import { RemoveAssetUpload, CancelAssetUpload } from '../action-creators';
import { CANCEL_ASSET_UPLOAD } from '../actions';
import AppState from '../../state';
import { assetsList, getAssetById } from '../selectors';
import { NoOp } from '@webapp/store/ui/action-creators';

export const cancelUploadEpic = (
  action$: Observable<Actions>,
  $state: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, CancelAssetUpload>(CANCEL_ASSET_UPLOAD),
    withLatestFrom($state),
    map(([action, state]) => {
      if (action.assetId) {
        const asset = getAssetById(state.assets, action.assetId);
        asset && asset.cancel();
        return asset ? new RemoveAssetUpload([action.assetId]) : new NoOp();
      } else {
        const assets = assetsList(state.assets, action.trackingId);
        assets.forEach((asset) => asset.cancel());

        return new RemoveAssetUpload(assets.map((a) => a.id));
      }
    })
  );
